export const childDashboardsUtilisation = [
	{id:"0", title:"Utilisation Summary", url:"homeutilisation"},
	{id:"00", title:"Focus Worksettings", url:"utilisationall/-100/1"},
	{id:"1", title:"Breakdown By Space Type/Organisation", url:"utilisationbreakdownbyspacetype"},
	{id:"2", title:"Utilisation Timeline", url:"utilisationtimeline"},
	{id:"3", title:"Daily & Weekly Profiles", url:"utilisationprofiles"},
	{id:"4", title:"Outliers", url:"utilisationoutliers"},
	{id:"5", title:"Hours Occupied, Utilisation & Capacity", url:"utilisationhoursoccupiedutilisationcapacity"},
	{id:"6", title:"Activity Analysis", url:"utilisationactivity"},
	{id:"7", title:"Unused Workplaces (Empty All Day)", url:"utilisationunuseddesks"},
	{id:"8", title:"Occupancy When In Use", url:"utilisationoccupancyinuse"},
	{id:"9", title:"Sensor Data", url:"utilisationsensors"},
	//{id:"10", title:"Worksetting Performance", url:"worksettingperformance"},
	{id:"11", title:"Room Bookings", url:"roombookings"}
];

